module.exports = __webpack_public_path__ + "static/media/moduleSet_i2o1.c6b8bfd4.jpg";